import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { DownloadFileService } from '../../../shared/services/download-file.service';
import { ApiService } from '../../../shared/services/api.service';
import { Urls } from '../../../utils/urls';
import { response } from 'express';
import { CommonDataService } from "@shared/services/common-data.service";

@Component({
  selector: 'app-statuory',
  templateUrl: './statuory.component.html',
  styleUrls: ['./statuory.component.scss']
})
export class StatuoryComponent implements OnInit {
  activeId = 0;

  topicList = [];

  statutoryList = [];

  subSection : any;

  section : any;

  months = [];

  year = [];

  isMobile = false;

  constructor(public downloadFileService: DownloadFileService, 
              private apiService: ApiService,
              private commonDataService: CommonDataService) { }

  ngOnInit() {
   this.scrollTop();
   this.getFiles();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getFiles = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getPartnerFiles, {type : 'Disclosure'}).subscribe((response: any) => {
      if ( response.data.typeList) {
        this.topicList = response.data.typeList;
        this.commonDataService.loaderStatus.next(false);
      }
    });
  }

  setActive = (id) => {
    this.activeId = id;
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  }


  public downloadFile(path, name){
    const fileName = path.split("/").pop();
    this.downloadFileService.export(path).subscribe(data => saveAs(data, fileName));
  }


  toggleSection(item:any){
    item.hide = !item.hide;
  }

  onMobileView(status: boolean){
      this.isMobile = status;
  }

}
